const benefits = [
  {
    icon: 'ri-search-eye-line',
    title: 'Find Trending Products',
    description: 'Discover popular products organized by categories. Our Sugargoo Spreadsheet compiles the most sought-after items so you never miss the latest trends.',
  },
  {
    icon: 'ri-time-line',
    title: 'Save Research Time',
    description: 'Access curated product information quickly. Skip the manual browsing and get straight to the products that matter with organized spreadsheet data.',
  },
  {
    icon: 'ri-scales-3-line',
    title: 'Compare Options',
    description: 'Review products before purchasing. Compare prices, styles, and categories side by side to make informed shopping decisions.',
  },
  {
    icon: 'ri-book-open-line',
    title: 'Learn Sugargoo',
    description: 'Understand warehouse operations, shipping methods, and ordering processes. Our guides help beginners navigate the platform with confidence.',
  },
  {
    icon: 'ri-shield-check-line',
    title: 'Verified Resources',
    description: 'All spreadsheet data is regularly updated and verified. We ensure the information you access is current and reliable for your shopping needs.',
  },
  {
    icon: 'ri-global-line',
    title: 'Global Community',
    description: 'Join thousands of shoppers worldwide who use Sugargoo Spreadsheet to enhance their product discovery and shopping experience.',
  },
];

export default function BenefitsSection() {
  return (
    <section id="benefits" className="py-14 md:py-20 px-4 md:px-6 bg-background-50">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-10">
          <span className="inline-block px-3 py-1 rounded-full bg-accent-100 text-accent-700 text-xs font-medium mb-4">
            Why Choose Us
          </span>
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-900 mb-3">
            Why Thousands of Users Search Sugargoo Spreadsheet
          </h2>
          <p className="text-sm md:text-base text-foreground-600 max-w-2xl mx-auto">
            Our Sugargoo Spreadsheet resources help shoppers worldwide discover products faster, compare options effectively, and shop smarter.
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6">
          {benefits.map((benefit) => (
            <div key={benefit.title} className="group p-6 rounded-lg bg-background-100/70 hover:bg-background-100 transition-colors duration-200">
              <div className="w-10 h-10 flex items-center justify-center rounded-lg bg-primary-100 text-primary-600 mb-4 group-hover:bg-primary-500 group-hover:text-background-50 transition-colors duration-300">
                <i className={`${benefit.icon} text-lg`}></i>
              </div>
              <h3 className="text-base font-semibold text-foreground-900 mb-2">{benefit.title}</h3>
              <p className="text-sm text-foreground-600 leading-relaxed">{benefit.description}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}